import { CamposGenericos } from "./camposGenericos";

export class Direccion extends CamposGenericos {

    calleNro: string;
    ciudad: string;
    cliente: string;
    codigoPostal: string;
    direccionEnvio: boolean;
    direccionFacturacion: boolean;
    funcionPartner: string;
    idCompania: string;
    idPais: string;
    idSalesOrg: string;
    nombre: string;
    nombreCliente:string;
    nroCliente: string;
    nroClientePartner: string;
    pais:string;
    provincia: string;
    status: string;
    codigoCoagra: string;
    mensajeStatus: string;

}
